export default __webpack_public_path__ + "static/media/home_games.7d9fefd7.jpg";